import { TrainingStatusEnum } from '../stores/rasaStatusStore'

import axiosAuth from './axiosAuth'

export const getRasaStatus = (controller: AbortController) =>
    axiosAuth.get<TrainingStatusEnum>('/rasa_status', {
        signal: controller.signal,
    })

export const getTraining = (controller: AbortController) =>
    axiosAuth.get<TrainingStatusEnum>(`/train`, {
        signal: controller.signal,
    })

export const postTraining = () => axiosAuth.post(`/train`)

export const getEval = (controller: AbortController) =>
    axiosAuth.get(`/eval`, {
        signal: controller.signal,
    })

export const postEval = () => axiosAuth.post<TrainingStatusEnum>(`/eval`)
